import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './OnboardingCard.css';

const cx = classnames.bind(styles);

function OnboardingCard({label, description, imageUrl, name, className, index, nextStep}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <div className={styles.infoWrapper}>
                <p className={styles.name}>{name}</p>
                <p className={styles.description}>{label}</p>
            </div>
            <div className={styles.steps}>
                <div className={styles.step}>
                    <p className={cx('stepIndex', 'stepCurrentIndex')}>{index}.</p>
                    <p className={styles.stepDescription}>{description}</p>
                    <img
                        className={styles.stepImage}
                        src={imageUrl}
                        alt={name}
                        loading='lazy'
                    />
                </div>
                <div className={styles.step}>
                    <p className={styles.stepIndex}>{nextStep.index}.</p>
                    <p className={styles.stepDescription}>{nextStep.description}</p>
                    <img
                        className={styles.stepImage}
                        src={nextStep.imageUrl}
                        alt={nextStep.description}
                        loading='lazy'
                    />
                </div>
            </div>
        </div>
    );
}

OnboardingCard.propTypes = {
    imageUrl: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    nextStep: PropTypes.object.isRequired,
    className: PropTypes.string
};

export {
    OnboardingCard
};
